<template>
  <baseEdit />
</template>

<script>
  import baseEdit from './baseEdit';

  export default {
    name: 'paymentApplyDetailCK',
    components: {
      baseEdit,
    },
  };
</script>
